import React from 'react';
import { t } from 'i18next';
import { useClient } from 'jsonapi-react';
import toast from 'react-hot-toast';
import { BadgeTruncate } from '@/components/ui/badge';
import { TableCell, TableRow, TableHead, TableTitle } from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import usePlayfulStudent from '@/hooks/usePlayfulStudent';

export function StudyGuideMatterModalRow(props) {
  const { taxonomy, onUpdate, isSelected, onSelectChange } = props;
  const taxonomyChildren = taxonomy?.['taxonomy-children'] || [];

  const playful = usePlayfulStudent();
  const client = useClient();

  const updateTaxonomy = async (id, attributes) => {
    try {
      const response = await client.mutate(`user_taxonomies/${id}`, attributes, { method: 'PUT' });
      return response.data;
    } catch (error) {
      console.error('Failed to update taxonomy:', error);
      toast.error('erro ao atualizar taxonomia');
    }
  };

  const handleAdd = async () => {
    const updatedTaxonomy = await updateTaxonomy(taxonomy.id, { 'manual-add': true });
    if (updatedTaxonomy) {
      onSelectChange(taxonomy.id, true);
      if (onUpdate) onUpdate(updatedTaxonomy);
    }
  };

  const handleRemoveMatter = async () => {
    const updatedTaxonomy = await updateTaxonomy(taxonomy.id, { 'manual-add': false });
    if (updatedTaxonomy) {
      onSelectChange(taxonomy.id, false);
      if (onUpdate) onUpdate(updatedTaxonomy);
    }
  };

  return (
    <TableRow>
      <TableHead
        scope="row"
        className="w-[200px]"
      >
        <TableTitle>{taxonomy?.['taxonomy-name']}</TableTitle>
      </TableHead>
      <TableCell>
        <BadgeTruncate
          items={taxonomyChildren}
          oneLine
        />
      </TableCell>
      <TableCell className="w-[140px]">
        <Button
          variant={isSelected ? 'default' : 'outline'}
          fullWidth
          style={playful ? (isSelected ? { background: 'var(--color-secondary)', borderColor: 'var(--color-secondary)' } : { borderColor: 'var(--color-secondary)', color: 'var(--color-secondary)' }) : undefined}
          onClick={() => {
            if (isSelected) {
              handleRemoveMatter();
            } else {
              handleAdd();
            }
          }}
        >
          {isSelected ? t('button.remove') : t('button.add')}
        </Button>
      </TableCell>
    </TableRow>
  );
}
